import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import * as firebase from 'firebase'
import { ThemeProvider } from 'styled-components'
import './index.css'
import { theme } from './style'
import App from './App'
import './i18n'
import * as serviceWorker from './serviceWorker'

const {
    REACT_APP_FIREBASE_API_KEY,
    REACT_APP_FIREBASE_AUTH_DOMAIN,
    REACT_APP_FIREBASE_DB_URL,
    REACT_APP_FIREBASE_PROJECT_ID,
} = process.env

firebase.initializeApp({
    apiKey: REACT_APP_FIREBASE_API_KEY,
    authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: REACT_APP_FIREBASE_DB_URL,
    projectId: REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: '<your-storage-bucket>',
    // messagingSenderId: '<your-sender-id>'
})

ReactDOM.render(
    <React.StrictMode>
        <Suspense fallback={null}>
            <ThemeProvider theme={theme}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ThemeProvider>
        </Suspense>
    </React.StrictMode>,
    document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
